import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";

import IconSelector from "components/shared/images/IconSelector";

const AddServerToCluster = ({ server_id }: { server_id: number }): ReactElement => {
 const navigate = useNavigate();
 const theme = useTheme();
 const desktopViewPort = useMediaQuery(theme.breakpoints.up("lg"));

 const paperStyle = {
  maxHeight: "fit-content",
  px: 5,
  py: 2,
  minWidth: desktopViewPort ? 300 : "auto",
  cursor: "pointer",
  "&:hover": {
   backgroundColor: "#fafafa"
  }
 };

 const handleGoToCreation = () => {
  navigate(`/servers/cluster/${server_id}/add`);
 };

 return (
  <Paper sx={paperStyle} onClick={handleGoToCreation}>
   <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
    <Typography
     color="kxOrange"
     variant="unboundedTitle"
     fontSize={16}
     textTransform="uppercase"
     fontWeight="bold">
     <FormattedMessage id="cluster.addNode" />
    </Typography>
    <IconSelector icon="AddIcon" props={{ color: "kxOrange" }} />
   </Stack>
  </Paper>
 );
};

export default AddServerToCluster;
